export default "__VITE_ASSET__B$26vS7f__"